import { handleActions } from "redux-actions";
import * as actionCreators from "../actions";
import setupApplication from "./setupApplication";
import destroyApplication from "./destroyApplication";
import updateActiveStep from "./updateActiveStep";
import updateOpenedCards from "./updateOpenedCards";
import triggerFieldActions from "./triggerFieldActions";
import updateField from "./updateField";
import verifySavedCards from "./verifySavedCards";
import updateSavedCards from "./updateSavedCards";
import updateSubmittedApplication from "./updateSubmittedApplication";

export const initialState = {
  save: {
    cardsList: [],
    data: {},
    content: undefined,
    error: undefined,
    success: undefined
  },
  submit: {
    isActive: false,
    content: undefined,
    error: undefined,
    success: undefined
  }
};

export default handleActions(
  {
    [actionCreators.setupApplication]: setupApplication,
    [actionCreators.destroyApplication]: destroyApplication,
    [actionCreators.updateActiveStep]: updateActiveStep,
    [actionCreators.updateOpenedCards]: updateOpenedCards,
    [actionCreators.triggerFieldActions]: triggerFieldActions,
    [actionCreators.updateField]: updateField,
    [actionCreators.verifySavedCards]: verifySavedCards,
    [actionCreators.updateSavedCards]: updateSavedCards,
    [actionCreators.updateSubmittedApplication]: updateSubmittedApplication
  },
  initialState
);
